export const EXTERNAL_LINKS = {
  PORTAL: process.env.REACT_APP_PORTAL_URL,
}
